import React from 'react';
import {
    CallRequestOverlayContainerProps,
    CallRequestOverlayViewProps,
} from './callRequestOverlayProps';
import { ChatContainerBaseConfig } from '../../../base';
import { CallRequestOverlayController } from './callRequestOverlayInterface';
import { CallStatus } from '@varos/call-core';

export function createCallRequestOverlayContainer(
    config: ChatContainerBaseConfig,
    controller: CallRequestOverlayController,
    View: React.FC<CallRequestOverlayViewProps>
): React.FC<CallRequestOverlayContainerProps> {
    const {
        context: { useContext },
    } = config;

    return ({ ...containerProps }) => {
        const context = useContext();
        const [callStatus, setCallStatus] = React.useState<CallStatus>('connecting');

        const props = controller.useProps(
            context,
            {},
            {
                item: containerProps.item,
                isOpen: containerProps.isOpen,
                onClose: containerProps.onClose,
                onEnd: containerProps.onEnd,
                callStatus: callStatus,
            }
        );

        // Add the status change callback to the upsert props
        const enhancedUpsertProps = {
            ...props.content,
            onStatusChange: setCallStatus,
        };

        return <View {...{ ...props, content: enhancedUpsertProps }} />;
    };
}
